export const AUTH_TOKEN_KEY = 'auth-token';

export const setAuthToken = (/** @type {string} */ token) => {
	localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const getAuthToken = () => {
	return localStorage.getItem(AUTH_TOKEN_KEY);
};

export const removeAuthToken = () => {
	localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const isAuthenticated = () => {
	return !!getAuthToken();
};
